<div class="votes-panel" [class.greyed]="votes == 'noApplication'">
  <h3 class="dashboard-box-header">Diese Händler haben für dich gestimmt</h3>

  <div class="handelspartnerGrid">
    <div *ngFor="let h of handelspartners" class="handelspartner" [class.vote]="h.vote">
      <img [src]="'./assets/img/partners/' + h.slug + '.png'" alt="" />
    </div>
  </div>
  <p>Nach dem Pitch siehst Du hier, welche Händler sich für Dein Produkt interessieren.</p>
</div>
